<template>
  <div class="content">
     <div class="card-deck p-md-5">
        <div class="card m-1" v-if="hasAnyRole('ROLE_ADMIN','ROLE_YUKYU_READ','ROLE_YUKYU_ADMIN')">
            <div class="card-header p-3" style="position:relative;">
                <a style="display:table" href="/admin/leave-request/top">
                    <i class="far fa-thumbs-up fa-5x"></i>休暇申請管理
                </a>
                <div class="btn-group" style="padding:10px 0 0;" v-if="hasAnyRole('ROLE_ADMIN','ROLE_YUKYU_ADMIN')">
                    <button id="yukyuBulkApproval" class="btn btn-primary btn-sm m-1" disabled="disabled" @click="yukyuBulkConfirm()">
                        一括承認
                    </button>
                    <modal ref="yukyuBulkModal" @ok="yukyuBulkStatusUpdate('confirm')"></modal>
                </div>
                <div style="position:absolute; bottom:0px; right:10px;">未承認({{yukyuList.length}})</div>
            </div>
            <div class="card-block p-1">
                <div v-if="yukyuList.length == 0">未承認のレコードはありません</div>
                <div v-else>
                    <table class="table table-bordered table-responsive">
                        <thead class="thead-light">
                        <tr>
                            <th v-if="hasAnyRole('ROLE_ADMIN','ROLE_YUKYU_ADMIN')">
                                <div class="checkbox noflap">
                                <label>
                                    <input type="checkbox" id="yukyuAllCheck" @click="yukyuCheckAll">
                                    <span class="checkbox-material"><span class="check"></span></span></input>
                                </label>
                                </div>
                            </th>
                            <th>氏名</th>
                            <th>対象日</th>
                            <th>種類</th>
                            <!--<th>全休/半休</th>-->
                            <!--<th>申請理由</th>-->
                            <th>ステータス</th>
                            <th>承認/取消</th>
                            <th>申請日</th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(result, index) in yukyuList" :key="index">
                                <td v-if="hasAnyRole('ROLE_ADMIN','ROLE_YUKYU_ADMIN')">
                                    <div class="checkbox noflap">
                                        <label>
                                            <input class="yukyuCheck" type="checkbox" name="idList" :value="result.userId + ',' + result.targetDate" @click="yukyuCheckSingle">
                                            <span class="checkbox-material"><span class="check"></span></span></input>
                                        </label>
                                    </div>
                                </td>
                                <td>{{result.userName}}</td>
                                <td>{{result.targetDate}}</td>
                                <td>
                                    <span v-if="result.requestType == 1">有給</span>
                                    <span v-else-if="result.requestType == 2">特別休暇（{{result.specialLeaveName}}）</span>
                                </td>
                                <!--<td>{{result.type}}</td>-->
                                <!--<td>{{result.reason}}</td>-->
                                <td>{{result.status}}</td>
                                <td>
                                    <div v-if="hasAnyRole('ROLE_ADMIN','ROLE_YUKYU_ADMIN')">
                                        <div v-if="result.status==='申請中' || result.status==='差し戻し'">
                                            <button type="button" class="btn btn-primary btn-sm" @click="updateYukyuStatus('confirm', result.userId, result.targetDate)">承認</button>
                                        </div>
                                        <div v-if="result.status==='承認済み'">
                                            <button type="button" class="btn btn-sm" @click="updateYukyuStatus('remand', result.userId, result.targetDate)">差し戻し</button>
                                        </div>
                                    </div>
                                </td>
                                <td>{{result.createdAt | date}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="card m-1" v-if="hasAnyRole('ROLE_ADMIN','ROLE_KOTSUHI_READ','ROLE_KOTSUHI_ADMIN')">
            <div class="card-header p-3" style="position:relative;">
                <a style="display:table" href="/admin/kotsuhi/top">
                    <i class="fa fa-train fa-5x"></i>交通費管理
                </a>
                <div class="btn-group" style="padding:10px 0 0;" v-if="hasAnyRole('ROLE_ADMIN','ROLE_KOTSUHI_ADMIN')">
                    <button id="kotsuhiBulkApproval" class="btn btn-primary btn-sm m-1" disabled="disabled" @click="kotsuhiBulkConfirm()">
                        一括承認
                    </button>
                    <modal ref="kotsuhiBulkConfirm" @ok="kotsuhiBulkStatusUpdate('confirm')"></modal>
                </div>
                <div style="position:absolute; bottom:0px; right:10px;">未承認({{kotsuhiList.length}})</div>
            </div>
            <div class="card-block p-1">
                <div v-if="kotsuhiList.length == 0">未承認のレコードはありません</div>
                <div v-else>
                    <table class="table table-bordered table-responsive">
                        <thead class="thead-light">
                            <tr>
                                <th v-if="hasAnyRole('ROLE_ADMIN','ROLE_KOTSUHI_ADMIN')">
                                    <div class="checkbox noflap">
                                    <label>
                                        <input type="checkbox" id="kotsuhiAllCheck" @click="kotsuhiCheckAll">
                                        <span class="checkbox-material"><span class="check"></span></span></input>
                                    </label>
                                    </div>
                                </th>
                                <th>氏名</th>
                                <th>対象日</th>
                                <!--<th>出発駅</th>-->
                                <!--<th>到着駅</th>-->
                                <!--<th>使用路線</th>-->
                                <!--<th>種類</th>-->
                                <th>費用</th>
                                <th>ステータス</th>
                                <th>承認/取消</th>
                                <th>申請日</th>
                            </tr>
                        </thead>
                        <tbody th:remove="all-but-first">
                            <tr v-for="(result, index) in kotsuhiList" :key="index">
                                <td v-if="hasAnyRole('ROLE_ADMIN','ROLE_KOTSUHI_ADMIN')">
                                    <div class="checkbox noflap">
                                        <label>
                                            <input class="kotsuhiCheck" type="checkbox" name="idList" :value="result.id" @click="kotsuhiCheckSingle">
                                            <span class="checkbox-material"><span class="check"></span></span></input>
                                        </label>
                                    </div>
                                </td>
                                <td>{{result.userName}}</td>
                                <td>{{result.targetDate}}</td>
                                <!--<td>{{result.startStation}}</td>-->
                                <!--<td>{{result.endStation}}</td>-->
                                <!--<td>{{result.route}}</td>-->
                                <!--<td>{{result.type}}</td>-->
                                <td>{{result.expense}}</td>
                                <td>{{result.status}}</td>
                                <td>
                                    <div v-if="hasAnyRole('ROLE_ADMIN','ROLE_KOTSUHI_ADMIN')">
                                        <div v-if="result.status==='申請中' || result.status==='差し戻し'">
                                            <button type="button" class="btn btn-primary btn-sm" @click="updateKotsuhiStatus('confirm', result.id)">承認</button>
                                        </div>
                                        <div v-if="result.status==='承認済み'">
                                            <button type="button" class="btn btn-sm" @click="updateKotsuhiStatus('remand', result.id)">差し戻し</button>
                                        </div>
                                    </div>
                                </td>
                                <td>{{result.createdDate}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <!--<div class="card m-1" style="position:relative;">-->
        <!--<div class="card-header p-3">-->
        <!--<a style="display:block" href="/admin/user/top">-->
        <!--<i class="fa fa-user fa-5x"></i>ユーザ管理-->
        <!--</a>-->
        <!--</div>-->
        <!--<div class="card-block p-1">-->
        <!--<h4 class="card-title">検討中</h4>-->
        <!--<p class="card-text">検討中.</p>-->
        <!--</div>-->
        <!--</div>-->
    </div>
  </div>
</template>

<style scoped>
</style>

<script>
import moment from "moment";
import CommonAPI from '../../api/common-api'
import KotsuhiAPI from '../../api/kotsuhi-api'
import LeaveRequestAPI from '../../api/leave-request-api'
import Modal from '../Modal.vue'

export default {
  name: "admin-top",
  components: {
      Modal,
  },
  data() {
    return {
      loginUser: {
          role: ''
      },
      yukyuList: [],
      kotsuhiList: []
    }
  },
  watch: {
    '$root.$refs.asnHeader.$data.loginUser': function (val) {
        this.loginUser = val
        this.getUnapprovedYukyuList()
        this.getUnapprovedKotsuhiList()
    },
  },
  mounted () {
  },
  methods: {
    // 未承認の有給一覧取得
    async getUnapprovedYukyuList() {
      this.$root.$refs.loading.$data.show = true
      this.yukyuList = await LeaveRequestAPI.getUnapprovedYukyuList()
      this.$root.$refs.loading.$data.show = false
    },
    // 未承認の交通費一覧取得
    getUnapprovedKotsuhiList() {
      this.$root.$refs.loading.$data.show = true
      KotsuhiAPI.getUnapprovedKotsuhiList()
        .then(res => {
            this.kotsuhiList = res
            this.$root.$refs.loading.$data.show = false
        })
        .catch(err => {
            console.error(err)
            this.$root.$refs.loading.$data.show = false
        })
    },
    // 有給ステータス更新
    updateYukyuStatus (status, userId, targetDate) {
        this.$root.$refs.loading.$data.show = true
        LeaveRequestAPI.updateStatus(status, userId, targetDate)
            .then(res => {
                this.$root.$refs.loading.$data.show = false
                this.getUnapprovedYukyuList()
            })
            .catch(err => {
                console.error(err)
                this.$root.$refs.loading.$data.show = false
            })
    },
    // 有給全てチェック・外す
    yukyuCheckAll (){
      const boxCnt = $(".yukyuCheck").length;
      if($(".yukyuCheck:checked").length === boxCnt){
          $(".yukyuCheck").prop("checked",false);
          $("#yukyuBulkApproval").prop("disabled",true);
      }else{
          $(".yukyuCheck").prop("checked",true);
          $("#yukyuBulkApproval").prop("disabled",false);;
      }
    },
    // 有給個別チェック
    yukyuCheckSingle () {
      let boxCnt = $(".yukyuCheck").length;
      if($(".yukyuCheck:checked").length !== boxCnt){
          $("#yukyuAllCheck").prop("checked",false);
      }else{
          $("#yukyuAllCheck").prop("checked",true);
      }

      if($(".yukyuCheck:checked").length > 0){
          $("#yukyuBulkApproval").prop("disabled",false);
      }else{
          $("#yukyuBulkApproval").prop("disabled",true);
      }
    },
    // 一括承認確認
    yukyuBulkConfirm(){
        this.$refs.yukyuBulkModal.confirm("選択した申請を承認します")
    },
    // 有給一括承認
    yukyuBulkStatusUpdate (status) {
      this.$root.$refs.loading.$data.show = true
      let keyList = [];
      $(".yukyuCheck:checked").each(function(index, element){
          keyList.push(element.value);
      })
      LeaveRequestAPI.bulkStatusUpdate(status, keyList)
        .then(res => {
            this.$root.$refs.loading.$data.show = false
            this.$router.go({
                path: this.$router.path,
                query: {
                    t: + new Date()
                }
            })
        })
        .catch(err => {
            console.error(err)
            this.$root.$refs.loading.$data.show = false
        })
    },
    // 交通費承認
    updateKotsuhiStatus (status, id) {
        this.$root.$refs.loading.$data.show = true
        KotsuhiAPI.updateStatus(status, id)
            .then(res => {
                this.$root.$refs.loading.$data.show = false
                this.getUnapprovedKotsuhiList()
            })
            .catch(err => {
                console.error(err)
                this.$root.$refs.loading.$data.show = false
            })
    },
    // 交通費全てチェック・外す
    kotsuhiCheckAll (){
      const boxCnt = $(".kotsuhiCheck").length;
      if($(".kotsuhiCheck:checked").length === boxCnt){
          $(".kotsuhiCheck").prop("checked",false);
          $("#kotsuhiBulkApproval").prop("disabled",true);
          $("#kotsuhiBulkPaid").prop("disabled",true);
      }else{
          $(".kotsuhiCheck").prop("checked",true);
          $("#kotsuhiBulkApproval").prop("disabled",false);;
          $("#kotsuhiBulkPaid").prop("disabled",false);
      }
    },
    // 交通費個別チェック
    kotsuhiCheckSingle () {
      let boxCnt = $(".kotsuhiCheck").length;
      if($(".kotsuhiCheck:checked").length !== boxCnt){
          $("#kotsuhiAllCheck").prop("checked",false);
      }else{
          $("#kotsuhiAllCheck").prop("checked",true);
      }
      if($(".kotsuhiCheck:checked").length > 0){
          $("#kotsuhiBulkApproval").prop("disabled",false);
          $("#kotsuhiBulkPaid").prop("disabled",false);
      }else{
          $("#kotsuhiBulkApproval").prop("disabled",true);
          $("#kotsuhiBulkPaid").prop("disabled",true);
      }
    },
    // 一括承認確認
    kotsuhiBulkConfirm(){
        this.$refs.kotsuhiBulkConfirm.confirm("選択した申請を承認します")
    },
    // 交通費ステータス一括更新
    kotsuhiBulkStatusUpdate (status) {
      this.$root.$refs.loading.$data.show = true
      let keyList = [];
      $(".kotsuhiCheck:checked").each(function(index, element){
          keyList.push(element.value);
      })
      KotsuhiAPI.bulkStatusUpdate(status, keyList)
        .then(res => {
            this.$router.go({
                path: this.$router.path,
                query: {
                    t: + new Date()
                }
            })
        })
        .catch(err => {
            console.error(err)
            this.$root.$refs.loading.$data.show = false
        })
    },
    // 権限を持っているか判定
    hasAnyRole: function (...args) {
        for (var i = 0; i < arguments.length; i++) {
            if (this.loginUser.role.includes(arguments[i])) {
                return true
            }
        }
        return false
    }
  },
  computed: {
  },
  filters: {
    date: function (data) {
      return data ? moment.localeData().preparse(moment(data).format("YYYY-MM-DD")) : ''
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/assets/js/components/admin/AdminTop.vue